import { Form, Input } from 'antd';
import { useState } from 'react';
import { AiOutlineArrowLeft, AiOutlineMail } from 'react-icons/ai';
import { Link } from 'react-router-dom';

import { AuthLayout } from '../../../components/AuthLayout';
import { Button } from '../../../components/Common/Button';
import { Logo } from '../../../components/Common/Logo';
import { useMobileVersion } from '../../../hooks/useMobileVersion';
import { recoverPassword } from '../../../operations/auth';
import * as authRules from '../../../rules/auth';
import { ContainerAuth, FormAuth, LinkAuth } from '../../../styles/common/auth';
import { ContentStyled, ParagraphStyled } from './styles';

export const PasswordReset = () => {
  const isMobileVersion = useMobileVersion();

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async ({ email }: any) => {
    try {
      setIsLoading(true);
      await recoverPassword(email);
    } finally {
      setIsLoading(false);
    }
  };

  if (isMobileVersion) {
    return (
      <ContainerAuth>
        <Logo height={35} />
        <ContentStyled>
          <h2>
            <Link to="/login">
              <AiOutlineArrowLeft />
            </Link>
            Recuperar senha
          </h2>
          <p>
            Insira seu email abaixo que iremos lhe encaminhar um email para
            criação de uma nova senha.
          </p>
          <FormAuth onFinish={handleSubmit}>
            <Form.Item name="email" rules={authRules.email}>
              <Input
                prefix={<AiOutlineMail />}
                placeholder="Email"
                size="large"
              />
            </Form.Item>
            <Button block htmlType="submit" loading={isLoading}>
              Enviar
            </Button>
          </FormAuth>
        </ContentStyled>
      </ContainerAuth>
    );
  }

  return (
    <AuthLayout>
      <ParagraphStyled>
        Digite seu e-mail para redefinirmos a senha
      </ParagraphStyled>
      <FormAuth onFinish={handleSubmit} style={{ maxWidth: 330 }}>
        <Form.Item name="email" rules={authRules.email}>
          <Input prefix={<AiOutlineMail />} placeholder="Email" size="large" />
        </Form.Item>
        <Button block htmlType="submit" loading={isLoading}>
          Enviar
        </Button>
      </FormAuth>
      <LinkAuth style={{ marginTop: '10px' }} to="/login">
        Fazer login
      </LinkAuth>
    </AuthLayout>
  );
};
